import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useCallback } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat } from '../common/function';
import { getBrand } from '../../config/brand';
import { renderRevealAccountCell, useRevealAccounts, useRevealSplitAccounts } from './revealAccounts';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// dayjs timezone 플러그인 활성화
dayjs.extend(utc);
dayjs.extend(timezone);

function SettlementAgentDepositStay() {
    const brand = getBrand();
    const showTerminal = brand.key !== 'baekma';
    const isMonthly = ['fast', 'onu'].includes(brand.key);
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);
    const isBaekmaTestAdmin = brand.key === 'baekma' && MyData?.admin_id === 'test';
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)

    // 주간 정산 기간 생성 (inbiz)
    const generateWeeklyPeriods = () => {
        const periods = [];
        const today = dayjs();

        // 첫 번째 기간: 2026-04-01 ~ 2026-04-12
        periods.push({
            value: '2026-04-01~2026-04-12',
            startDate: '2026-04-01',
            endDate: '2026-04-12',
            label: '2026-04-01 ~ 2026-04-12'
        });

        // 이후 주단위: 월~일 (일요일 정산 완료 주까지만 포함)
        let weekStart = dayjs('2026-04-13');
        while (weekStart.add(6, 'day').isBefore(today, 'day') || weekStart.add(6, 'day').isSame(today, 'day')) {
            const weekEnd = weekStart.add(6, 'day');
            periods.push({
                value: `${weekStart.format('YYYY-MM-DD')}~${weekEnd.format('YYYY-MM-DD')}`,
                startDate: weekStart.format('YYYY-MM-DD'),
                endDate: weekEnd.format('YYYY-MM-DD'),
                label: `${weekStart.format('YYYY-MM-DD')} ~ ${weekEnd.format('YYYY-MM-DD')}`
            });
            weekStart = weekStart.add(7, 'day');
        }

        return periods.reverse(); // 최신순
    };

    // 월간 정산 기간 생성 (fast, onu): 2025-12 ~ 현재월
    const generateMonthlyPeriods = () => {
        const periods = [];
        const today = dayjs();
        let cursor = dayjs('2025-12-01');
        while (cursor.isBefore(today, 'month') || cursor.isSame(today, 'month')) {
            const ym = cursor.format('YYYY-MM');
            periods.push({
                value: ym,
                settlementMonth: ym,
                startDate: cursor.startOf('month').format('YYYY-MM-DD'),
                endDate: cursor.endOf('month').format('YYYY-MM-DD'),
                label: ym,
            });
            cursor = cursor.add(1, 'month');
        }
        return periods.reverse();
    };

    const [periodList] = useState(() => isMonthly ? generateMonthlyPeriods() : generateWeeklyPeriods());
    const [selectedPeriod, setSelectedPeriod] = useState(() => {
        return periodList.length > 0 ? periodList[0].value : '';
    });

    const getSelectedPeriodObj = () => {
        return periodList.find(p => p.value === selectedPeriod) || periodList[0];
    };

    const matchesSelectedPeriod = (item, period) => {
        if (!period) return true;

        const dateStr = (item.requested_at || item.created_at || item.settlement_date || '').split(' ')[0];
        if (isMonthly) {
            if (dateStr) return dateStr.slice(0, 7) === period.value;
            if (item.settlement_month) return String(item.settlement_month).slice(0, 7) === period.value;
            return true;
        }

        if (item.settlement_month) {
            const settlementMonth = String(item.settlement_month);
            return settlementMonth === period.label || settlementMonth === period.value;
        }

        if (dateStr) {
            return dateStr >= period.startDate && dateStr <= period.endDate;
        }

        return true;
    };

    useEffect(() => {
        dispatch(change_Current_Location("영업자입금대기내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    const handlePeriodChange = (event) => {
        setSelectedPeriod(event.target.value);
        setPage(1);
        setReload(e => !e);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, selectedPeriod])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        const period = getSelectedPeriodObj();
        // 대기 상태 내역만 조회
        await axios.get(process.env.REACT_APP_API + "/api/agent-payout/pending", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                ...(isMonthly
                    ? { settlementMonth: period?.settlementMonth }
                    : { startDate: period?.startDate, endDate: period?.endDate }),
                agentId: selectedText || undefined, // 영업자 ID 필터 (선택사항)
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code === 1000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.payoutList ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.payoutList ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            setSpinner(false)
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "정산기간", "width": "155px", "textAlign": "center" },
        { "no": 3, "text": "영업자명", "width": "200px", "textAlign": "center" },
        { "no": 4, "text": "원금액", "width": "95px", "textAlign": "center" },
        ...(showTerminal ? [
            { "no": 4.1, "text": "단말기 개수", "width": "90px", "textAlign": "center" },
            { "no": 4.2, "text": "단말기 차감액", "width": "100px", "textAlign": "center" },
        ] : []),
        { "no": 4.3, "text": "입금액", "width": "95px", "textAlign": "center" },
        { "no": 4.4, "text": "입금방식", "width": "70px", "textAlign": "center" },
        { "no": 5.1, "text": "상태", "width": "60px", "textAlign": "center" },
        { "no": 6, "text": "예금주", "width": "150px", "textAlign": "center" },
        { "no": 8, "text": "은행", "width": "120px", "textAlign": "center" },
        { "no": 7, "text": "입금계좌", "width": "150px", "textAlign": "left" },
        { "no": 9, "text": "적요", "width": "120px", "textAlign": "center" },
        { "no": 9.5, "text": "상계사유", "width": "150px", "textAlign": "center" },
        { "no": 5, "text": "상계", "width": "100px", "textAlign": "center" },
        { "no": 99, "text": "", "skeleton": true },
    ];

    const [checkedIds, setCheckedIds] = useState([]);

    // 상계처리 모달 상태
    const [offsetModal, setOffsetModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [offsetData, setOffsetData] = useState({
        offsetAmt: '', // 상계 후 금액 (requested_amount로 저장될 값)
        offsetMemo: ''
    });

    // 단말기 개수 적용 모달 상태
    const [terminalModal, setTerminalModal] = useState(false);
    const [selectedTerminalRow, setSelectedTerminalRow] = useState(null);
    const [terminalData, setTerminalData] = useState({
        terminalCount: '',
        terminalMemo: ''
    });

    // 상계처리 이력 모달 상태
    const [offsetHistoryModal, setOffsetHistoryModal] = useState(false);
    const [offsetHistory, setOffsetHistory] = useState([]);
    const [payoutInfo, setPayoutInfo] = useState(null);

    // 계좌 분할 모달 상태
    const [splitModal, setSplitModal] = useState(false);
    const [selectedSplitRow, setSelectedSplitRow] = useState(null);
    const [splitData, setSplitData] = useState({
        firstMerchantName: '',
        firstBankCode: '',
        firstAccountNumber: '',
        firstAccountHolder: '',
        firstAmount: '',
        firstMemo: '',
        secondMerchantName: '',
        secondBankCode: '',
        secondAccountNumber: '',
        secondAccountHolder: '',
        secondAmount: '',
        secondMemo: '',
        splitReason: ''
    });
    const [availableAccounts, setAvailableAccounts] = useState([]);
    const [bankInfoList, setBankInfoList] = useState([]);

    // 분할 이력 모달 상태
    const [splitHistoryModal, setSplitHistoryModal] = useState(false);
    const [splitHistory, setSplitHistory] = useState([]);
    const [splitPayoutInfo, setSplitPayoutInfo] = useState(null);
    const { getRevealedAccount, isRevealLoading, revealAccount } = useRevealAccounts({
        enabled: isBaekmaTestAdmin,
        endpoint: '/api/agent-payout/reveal-accounts',
    });
    const { getRevealedSplitAccount, isSplitRevealLoading, revealSplitAccount } = useRevealSplitAccounts({
        enabled: isBaekmaTestAdmin,
        endpoint: '/api/agent-payout/reveal-split-accounts',
    });

    const getAccountNumberDisplay = useCallback((data) => (
        isBaekmaTestAdmin ? (getRevealedAccount(data?.id)?.account_number || data?.account_number_masked) : data?.account_number
    ) || '', [isBaekmaTestAdmin, getRevealedAccount]);

    const getAccountHolderDisplay = useCallback((data) => (
        isBaekmaTestAdmin ? (getRevealedAccount(data?.id)?.account_holder || data?.account_holder_masked) : data?.account_holder
    ) || '', [isBaekmaTestAdmin, getRevealedAccount]);

    const getSplitAccountNumberDisplay = useCallback((log, type) => {
        const logId = log?.id || log?.log_id;
        const revealed = getRevealedSplitAccount(logId);
        if (type === 'first') {
            return (isBaekmaTestAdmin ? (revealed?.first_account_number || log?.first_account_number_masked) : log?.first_account_number) || '-';
        }
        return (isBaekmaTestAdmin ? (revealed?.second_account_number || log?.second_account_number_masked) : log?.second_account_number) || '-';
    }, [isBaekmaTestAdmin, getRevealedSplitAccount]);

    // 보류 처리 모달 상태
    const [holdModal, setHoldModal] = useState(false);
    const [selectedHoldRow, setSelectedHoldRow] = useState(null);
    const [holdData, setHoldData] = useState({
        adminMemo: ''
    });

    // 보류 해제 모달 상태
    const [releaseModal, setReleaseModal] = useState(false);
    const [selectedReleaseRow, setSelectedReleaseRow] = useState(null);
    const [releaseData, setReleaseData] = useState({
        adminMemo: ''
    });

    // 상계처리 모달 열기
    const openOffsetModal = (row) => {
        setSelectedRow(row);
        setOffsetData({
            offsetAmt: row.requested_amount ? Math.floor(parseFloat(row.requested_amount)).toString() : '',
            offsetMemo: ''
        });
        setOffsetModal(true);
    };

    // 단말기 개수 적용 모달 열기
    const openTerminalModal = (row) => {
        setSelectedTerminalRow(row);
        setTerminalData({
            terminalCount: row.terminal_count ? row.terminal_count.toString() : '',
            terminalMemo: ''
        });
        setTerminalModal(true);
    };

    // 단말기 개수 적용 실행
    const handleTerminalSubmit = async () => {
        if (!terminalData.terminalCount) {
            alert('단말기 개수를 입력해주세요.');
            return;
        }

        const terminalCount = parseInt(terminalData.terminalCount);
        if (terminalCount < 0) {
            alert('단말기 개수는 0 이상이어야 합니다.');
            return;
        }

        const deductionAmount = terminalCount * 11000;
        const currentFinalAmount = parseFloat(selectedTerminalRow?.final_amount || selectedTerminalRow?.requested_amount || 0);
        const newFinalAmount = parseFloat(selectedTerminalRow?.requested_amount || 0) - deductionAmount;

        // 확인 메시지
        if (!window.confirm(`단말기 개수를 적용하시겠습니까?\n\n단말기 개수: ${terminalCount}개\n차감 금액: ${changeNum(deductionAmount)}원\n현재 최종 금액: ${changeNum(currentFinalAmount)}원\n적용 후 최종 금액: ${changeNum(newFinalAmount)}원`)) {
            return;
        }

        try {
            const response = await axios.put(
                process.env.REACT_APP_API + `/api/agent-payout/${selectedTerminalRow.id}/terminal-count`,
                {
                    terminal_count: terminalCount,
                    admin_memo: terminalData.terminalMemo || undefined
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('단말기 개수가 성공적으로 적용되었습니다.');
                setTerminalModal(false);
                // 데이터 새로고침: 첫 페이지로 리셋하고 목록 다시 불러오기
                setPage(1);
                setReload(e => !e);
            } else {
                alert(response.data.msg || '단말기 개수 적용 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('단말기 개수 적용 오류:', error);
            alert('단말기 개수 적용 중 오류가 발생했습니다.');
        }
    };

    // 변경 금액 계산 (상계 전 금액 - 상계 후 금액)
    const calculateOffsetAmount = () => {
        const beforeAmount = parseFloat(selectedRow?.requested_amount || 0);
        const afterAmount = parseFloat(offsetData.offsetAmt || 0);
        return beforeAmount - afterAmount;
    };

    // 상계처리 이력 조회
    const fetchOffsetHistory = async (payoutId) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/agent-payout/offset-log',
                {
                    params: { id: payoutId },
                    withCredentials: true
                }
            );

            if (response.data.code === 1000) {
                setPayoutInfo(response.data.data.payout_info);
                setOffsetHistory(response.data.data.offset_logs);
                setOffsetHistoryModal(true);
            } else {
                alert(response.data.msg || '상계처리 이력을 조회할 수 없습니다.');
            }
        } catch (error) {
            console.error('상계처리 이력 조회 오류:', error);
            alert('상계처리 이력을 조회하는 중 오류가 발생했습니다.');
        }
    };

    // 은행 정보 조회
    const fetchBankInfo = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/payout/bank-info',
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                setBankInfoList(response.data.data.bank_info || []);
            }
        } catch (error) {
            console.error('은행 정보 조회 오류:', error);
        }
    };

    // 분할 이력 조회
    const fetchSplitHistory = async (payoutId) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/agent-payout/split-data',
                {
                    params: { payoutId: payoutId },
                    withCredentials: true
                }
            );

            if (response.data.code === 1000) {
                setSplitPayoutInfo(response.data.data.splitData[0]);
                setSplitHistory(response.data.data.splitData);
                setSplitHistoryModal(true);
            } else {
                alert(response.data.msg || '분할 이력을 조회할 수 없습니다.');
            }
        } catch (error) {
            console.error('분할 이력 조회 오류:', error);
            alert('분할 이력을 조회하는 중 오류가 발생했습니다.');
        }
    };

    // 계좌 분할 모달 열기
    const openSplitModal = async (row) => {
        setSelectedSplitRow(row);
        setSplitData({
            firstMerchantName: row.co_nm || row.agent_name || '',
            firstBankCode: row.bank_code || '',
            firstAccountNumber: getAccountNumberDisplay(row),
            firstAccountHolder: getAccountHolderDisplay(row),
            firstAmount: '',
            firstMemo: '',
            secondMerchantName: row.co_nm || row.agent_name || '',
            secondBankCode: '',
            secondAccountNumber: '',
            secondAccountHolder: '',
            secondAmount: '',
            secondMemo: '',
            splitReason: ''
        });

        // 은행 정보 조회 (한 번만)
        if (bankInfoList.length === 0) {
            await fetchBankInfo();
        }

        setSplitModal(true);
    };

    // 은행 코드를 은행명으로 변환
    const getBankName = (bankCode) => {
        const bank = bankInfoList.find(b => b.code === bankCode);
        return bank ? bank.bank_name : bankCode;
    };

    // trx_id 중복 체크 (분할된 데이터인지 확인)
    const isSplitData = (trxId) => {
        if (!listTrxData || !trxId || trxId === null || trxId === undefined || trxId === '') return false;
        const sameTrxIdCount = listTrxData.filter(item => item.trx_id === trxId).length;
        return sameTrxIdCount > 1;
    };

    // 분할 금액 계산 (자동 계산)
    const calculateSplitAmount = () => {
        const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
        const firstAmount = parseFloat(splitData.firstAmount || 0);
        const secondAmount = totalAmount - firstAmount;

        setSplitData(prev => ({
            ...prev,
            secondAmount: secondAmount > 0 ? secondAmount.toString() : ''
        }));
    };

    // 계좌 분할 실행
    const handleSplitSubmit = async () => {
        if (!splitData.firstBankCode || !splitData.firstAccountNumber || !splitData.firstAccountHolder ||
            !splitData.secondBankCode || !splitData.secondAccountNumber || !splitData.secondAccountHolder ||
            !splitData.firstAmount || !splitData.secondAmount) {
            alert('모든 필수 항목을 입력해주세요.');
            return;
        }

        const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
        const firstAmount = parseFloat(splitData.firstAmount);
        const secondAmount = parseFloat(splitData.secondAmount);

        // 금액 검증
        if (firstAmount <= 0 || secondAmount <= 0) {
            alert('분할 금액은 0보다 커야 합니다.');
            return;
        }

        if (Math.abs((firstAmount + secondAmount) - totalAmount) > 0.01) {
            alert('분할 금액의 합이 원본 금액과 일치하지 않습니다.');
            return;
        }

        // 확인 메시지
        if (!window.confirm(`계좌 분할을 진행하시겠습니까?\n\n원본 금액: ${changeNum(totalAmount)}\n첫 번째 계좌: ${getBankName(splitData.firstBankCode)} - ${splitData.firstAccountNumber} (${splitData.firstAccountHolder}) - ${changeNum(firstAmount)}\n두 번째 계좌: ${getBankName(splitData.secondBankCode)} - ${splitData.secondAccountNumber} (${splitData.secondAccountHolder}) - ${changeNum(secondAmount)}`)) {
            return;
        }

        try {
            const firstAccountNumberForSubmit = isBaekmaTestAdmin
                ? (selectedSplitRow?.account_number || splitData.firstAccountNumber)
                : splitData.firstAccountNumber;
            const firstAccountHolderForSubmit = isBaekmaTestAdmin
                ? (selectedSplitRow?.account_holder || splitData.firstAccountHolder)
                : splitData.firstAccountHolder;

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/agent-payout/split-deposit-account',
                {
                    id: selectedSplitRow.id,
                    firstBankCode: splitData.firstBankCode,
                    firstBankName: getBankName(splitData.firstBankCode),
                    firstAccountNumber: firstAccountNumberForSubmit,
                    firstAccountHolder: firstAccountHolderForSubmit,
                    firstAmount: firstAmount,
                    secondBankCode: splitData.secondBankCode,
                    secondBankName: getBankName(splitData.secondBankCode),
                    secondAccountNumber: splitData.secondAccountNumber,
                    secondAccountHolder: splitData.secondAccountHolder,
                    secondAmount: secondAmount,
                    firstMemo: splitData.firstMemo || undefined,
                    secondMemo: splitData.secondMemo || undefined,
                    splitReason: splitData.splitReason || undefined
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('계좌 분할이 완료되었습니다.');
                setSplitModal(false);
                // 데이터 새로고침
                ListData();
            } else {
                alert(response.data.msg || '계좌 분할 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('계좌 분할 오류:', error);
            alert('계좌 분할 중 오류가 발생했습니다.');
        }
    };

    // 상계처리 실행
    const handleOffsetSubmit = async () => {
        if (!offsetData.offsetAmt || !offsetData.offsetMemo) {
            alert('상계 후 금액과 메모를 입력해주세요.');
            return;
        }

        const beforeAmount = parseFloat(selectedRow?.requested_amount || 0);
        const afterAmount = parseFloat(offsetData.offsetAmt);
        const offsetAmount = beforeAmount - afterAmount;

        // 변경 금액이 0인 경우 처리
        if (offsetAmount === 0) {
            alert('변경할 금액이 없습니다. 상계 후 금액을 다시 확인해주세요.');
            return;
        }

        // 변경 금액 확인
        if (!window.confirm(`상계처리를 진행하시겠습니까?\n\n상계 전 금액: ${changeNum(beforeAmount)}원\n상계 후 금액: ${changeNum(afterAmount)}원\n상계 금액: ${changeNum(offsetAmount)}원`)) {
            return;
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + '/api/agent-payout/update-deposit-expected',
                {
                    id: selectedRow.id,
                    offsetAmt: afterAmount, // 상계 후 금액 (requested_amount로 저장될 값)
                    offsetMemo: offsetData.offsetMemo
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('상계처리가 완료되었습니다.');
                setOffsetModal(false);
                // 데이터 새로고침
                setReload(e => !e);
            } else {
                alert(response.data.msg || '상계처리 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('상계처리 오류:', error);
            alert('상계처리 중 오류가 발생했습니다.');
        }
    };

    // 보류 처리 모달 열기
    const openHoldModal = (row) => {
        setSelectedHoldRow(row);
        setHoldData({
            adminMemo: ''
        });
        setHoldModal(true);
    };

    // 보류 처리 실행
    const handleHoldSubmit = async () => {
        if (!selectedHoldRow) return;

        if (!window.confirm(`보류 처리를 진행하시겠습니까?\n\n영업자명: ${selectedHoldRow.co_nm || selectedHoldRow.agent_name}\n정산월: ${selectedHoldRow.settlement_month || '-'}`)) {
            return;
        }

        try {
            const response = await axios.put(
                process.env.REACT_APP_API + `/api/agent-payout/${selectedHoldRow.id}/hold`,
                {
                    admin_memo: holdData.adminMemo || undefined
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('보류 처리가 완료되었습니다.');
                setHoldModal(false);
                // 데이터 새로고침
                setReload(e => !e);
            } else {
                alert(response.data.msg || '보류 처리 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('보류 처리 오류:', error);
            alert('보류 처리 중 오류가 발생했습니다.');
        }
    };

    // 보류 해제 모달 열기
    const openReleaseModal = (row) => {
        setSelectedReleaseRow(row);
        setReleaseData({
            adminMemo: ''
        });
        setReleaseModal(true);
    };

    // 보류 해제 실행
    const handleReleaseSubmit = async () => {
        if (!selectedReleaseRow) return;

        if (!window.confirm(`보류 해제를 진행하시겠습니까?\n\n영업자명: ${selectedReleaseRow.co_nm || selectedReleaseRow.agent_name}\n정산월: ${selectedReleaseRow.settlement_month || '-'}`)) {
            return;
        }

        try {
            const response = await axios.put(
                process.env.REACT_APP_API + `/api/agent-payout/${selectedReleaseRow.id}/release`,
                {
                    admin_memo: releaseData.adminMemo || undefined
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('보류 해제가 완료되었습니다.');
                setReleaseModal(false);
                // 데이터 새로고침
                setReload(e => !e);
            } else {
                alert(response.data.msg || '보류 해제 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('보류 해제 오류:', error);
            alert('보류 해제 중 오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            const period = getSelectedPeriodObj();
            let list = (listTrxData ?? []).filter(item => {
                return matchesSelectedPeriod(item, period);
            });
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let date = data.created_at ? data.created_at.split(' ') : [];
                let settlementPeriod = data.settlement_month || '-';

                // 상계처리 여부 확인
                const hasOffset = data.offset_at !== null && data.offset_at !== undefined;
                // 보류 상태 확인
                const isHold = data.status === 'H' || data.status === '보류';
                // 분할된 데이터 여부 확인
                const isSplit = isSplitData(data.trx_id || data.id);
                const rowStyle = isHold ? { color: "#f59e0b", fontWeight: "500" } :
                    hasOffset ? { color: "#dc2626", fontWeight: "500" } : 
                    isSplit ? { color: "#1e40af", fontWeight: "500" } : {};

                // 단말기 정보 계산
                const terminalCount = data.terminal_count || 0;
                const terminalDeduction = terminalCount * 11000;
                const requestedAmount = parseFloat(data.fee_amount || 0);
                const finalAmount = parseFloat(data.final_amount || data.requested_amount || 0);

                tableBodyData.push([
                    { no: 1, text: settlementPeriod, width: "155px", textAlign: "center", style: { ...rowStyle, fontSize: "12px" } },
                    { no: 3, text: data.co_nm || data.agent_name || '-', width: "200px", textAlign: "left", style: rowStyle },
                    { no: 4, text: changeNum(requestedAmount), width: "95px", textAlign: "right", style: rowStyle },
                    ...(showTerminal ? [
                        {
                            no: 4.1,
                            text: (
                                <div style={{ position: "relative", width: "100%", height: "100%", display: "flex", alignItems: "center" }}>
                                    <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                                        {terminalCount > 0 ? (
                                            <span style={{
                                                color: "#059669",
                                                fontWeight: "500"
                                            }}>
                                                {terminalCount}개
                                            </span>
                                        ) : (
                                            <span style={{ color: "#9ca3af" }}>-</span>
                                        )}
                                    </div>
                                    {!isHold && (
                                        <div style={{ marginLeft: "auto" }}>
                                            <button
                                                className="btn btn-sm btn-secondary"
                                                onClick={() => openTerminalModal(data)}
                                                style={{
                                                    padding: "2px 6px",
                                                    fontSize: "10px",
                                                    borderRadius: "4px",
                                                    border: "1px solid #6b7280",
                                                    backgroundColor: "#f3f4f6",
                                                    color: "#374151",
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                설정
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ),
                            width: "100px",
                            textAlign: "center",
                            style: rowStyle
                        },
                        {
                            no: 4.2,
                            text: terminalDeduction > 0 ? (
                                <span style={{
                                    color: "#dc2626",
                                    fontWeight: "500"
                                }}>
                                    -{changeNum(terminalDeduction)}
                                </span>
                            ) : (
                                <span style={{ color: "#9ca3af" }}>-</span>
                            ),
                            width: "80px",
                            textAlign: "right",
                            style: rowStyle
                        },
                    ] : []),
                    {
                        no: 4.3,
                        text: changeNum(finalAmount),
                        width: "95px",
                        textAlign: "right",
                        style: { ...rowStyle, fontWeight: "700" }
                    },
                    { no: 4.4, text: data.payout_method || '-', width: "70px", textAlign: "center", style: rowStyle },
                    {
                        no: 5.1,
                        text: (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {!isHold ? (
                                    <button
                                        className="btn btn-sm"
                                        onClick={() => openHoldModal(data)}
                                        style={{
                                            padding: "4px 12px",
                                            fontSize: "12px",
                                            borderRadius: "4px",
                                            border: "1px solid #10b981",
                                            backgroundColor: "#10b981",
                                            color: "#ffffff",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            fontWeight: "500"
                                        }}
                                    >
                                        보류
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-sm"
                                        onClick={() => openReleaseModal(data)}
                                        style={{
                                            padding: "4px 12px",
                                            fontSize: "12px",
                                            borderRadius: "4px",
                                            border: "1px solid #dc2626",
                                            backgroundColor: "#dc2626",
                                            color: "#ffffff",
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            fontWeight: "500"
                                        }}
                                    >
                                        해제
                                    </button>
                                )}
                            </div>
                        ),
                        width: "60px",
                        textAlign: "center",
                        style: rowStyle
                    },
                    { no: 6, text: getAccountHolderDisplay(data), width: "150px", textAlign: "left", style: rowStyle },
                    { no: 8, text: data.bank_name, width: "120px", textAlign: "left", style: rowStyle },
                    {
                        no: 7,
                        text: renderRevealAccountCell({
                            enabled: isBaekmaTestAdmin,
                            id: data.id,
                            value: getAccountNumberDisplay(data),
                            revealed: !!getRevealedAccount(data.id),
                            loading: isRevealLoading(data.id),
                            onReveal: revealAccount,
                        }),
                        width: "150px",
                        textAlign: "left",
                        style: rowStyle
                    },
                    { no: 9, text: data.payout_memo, width: "120px", textAlign: "left", style: rowStyle },
                    { no: 9.5, text: <span title={data.offset_memo || ''}>{data.offset_memo || '-'}</span>, width: "150px", textAlign: "left", style: rowStyle },
                    {
                        no: 5,
                        text: !isHold ? (
                            <div style={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "wrap" }}>
                                <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => openOffsetModal(data)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: hasOffset ? "1px solid #dc2626" : "1px solid #f59e0b",
                                        backgroundColor: hasOffset ? "#fef2f2" : "#fbbf24",
                                        color: hasOffset ? "#dc2626" : "#92400e",
                                        cursor: "pointer"
                                    }}
                                >
                                    상계
                                </button>
                                <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => fetchOffsetHistory(data.id)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: hasOffset ? "1px solid #dc2626" : "1px solid #0ea5e9",
                                        backgroundColor: hasOffset ? "#fef2f2" : "#38bdf8",
                                        color: hasOffset ? "#dc2626" : "#0c4a6e",
                                        cursor: "pointer"
                                    }}
                                >
                                    이력
                                </button>
                            </div>
                        ) : (
                            <span style={{ color: "#9ca3af" }}>-</span>
                        ),
                        width: "100px",
                        textAlign: "center"
                    },
                    { no: 99, text: "", skeleton: true },
                ]);
            }
            setCombineData(tableBodyData);
        }
    }, [listTrxData, checkedIds, selectedPeriod, getAccountHolderDisplay, getAccountNumberDisplay, getRevealedAccount, isRevealLoading, revealAccount, isBaekmaTestAdmin]);

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const excelBtn = async () => {
        const period = getSelectedPeriodObj();
        await axios.get(process.env.REACT_APP_API + "/api/agent-payout/pending/excel", {
            withCredentials: true,
            params: {
                ...(isMonthly
                    ? { settlementMonth: period?.settlementMonth }
                    : { startDate: period?.startDate, endDate: period?.endDate }),
                agentId: selectedText || undefined,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.payoutList ?? [])
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                let settlementPeriod = t.settlement_month || '-';

                try {
                    arr.push({
                        "정산기간": settlementPeriod,
                        "영업자명": t.co_nm || t.agent_name || '-',
                        "입금액": t.final_amount || t.requested_amount,
                        "예금주": getAccountHolderDisplay(t),
                        "입금계좌": getAccountNumberDisplay(t),
                        "은행": t.bank_name,
                        "적요": t.payout_memo,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }

    const onSubmit = async () => {
        const period = getSelectedPeriodObj();
        const periodParams = isMonthly
            ? { settlementMonth: period?.settlementMonth }
            : { startDate: period?.startDate, endDate: period?.endDate };
        const confirmPeriod = period?.label || selectedPeriod || '선택 기간';

        if (window.confirm(`${confirmPeriod} 건을 입금확정 하시겠습니까?`)) {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API + "/api/agent-payout/confirm",
                    {
                        ...periodParams,
                        agentId: selectedText || undefined,
                    },
                    {
                        withCredentials: true,
                        params: {
                            ...periodParams,
                            agentId: selectedText || undefined,
                        },
                    }
                );

                if (response.data.code === 1000) {
                    const { updatedCount, totalCount } = response.data.data || {};
                    alert(`입금 확정 처리가 완료되었습니다.\n\n처리된 건수: ${updatedCount || 0}건\n전체 건수: ${totalCount || 0}건`);
                    setReload(e => !e);
                } else {
                    alert(response.data.msg || '입금 확정 처리 중 오류가 발생했습니다.');
                }
            } catch (error) {
                console.error('입금 확정 처리 오류:', error);
                alert('입금 확정 처리 중 오류가 발생했습니다.');
            }
        }
    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form" onSubmit={(e) => e.preventDefault()}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <label style={{ minWidth: "80px", fontWeight: "500", fontSize: "14px" }}>정산월:</label>
                            <select
                                value={selectedPeriod}
                                onChange={handlePeriodChange}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    height: "30px",
                                    width: "280px"
                                }}
                            >
                                {periodList.map((period) => (
                                    <option key={period.value} value={period.value}>
                                        {period.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                    </div>
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div className="button_wrap" style={{ marginTop: "0px" }}>
                        <button onClick={() => { onSubmit() }} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px" }}>
                            입금확정
                        </button>
                    </div>
                    <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                        <div className='excel-disable' style={{ width: "auto" }}>
                            <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />

                            <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        </div>
                    </div>
                </div>
                <List
                    tableHeaderData={tableHeaderData}
                    tableBodyData={listTrxData ?? 0}
                    filter_tableBodyData={combineData}
                    page={page}
                    setPage={setPage}
                    maxFirstPage={maxFirstPage}
                    observerRef={observerRef}
                    nonePage={false}
                    scrollState={true}
                    spinner={spinner}
                    height={"700px"}
                />
            </div>

            {/* 상계처리 모달 - 기존 코드와 동일 */}
            {offsetModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "400px",
                        maxWidth: "500px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>상계 처리</h3>
                            <button
                                className="btn-close"
                                onClick={() => setOffsetModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    영업자명
                                </label>
                                <input
                                    type="text"
                                    value={selectedRow?.co_nm || selectedRow?.agent_name || ''}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    상계 전 금액 (원금액)
                                </label>
                                <input
                                    type="text"
                                    value={changeNum(parseFloat(selectedRow?.requested_amount || 0))}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                                <small style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    단말기 차감 전 원본 금액입니다
                                </small>
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    상계 후 금액 *
                                </label>
                                <input
                                    type="text"
                                    value={offsetData.offsetAmt}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setOffsetData({
                                            ...offsetData,
                                            offsetAmt: value
                                        });
                                    }}
                                    className="form-control"
                                    placeholder="상계 후 금액을 입력하세요 (숫자만)"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px"
                                    }}
                                />
                                <small style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    상계 처리 후 원금액입니다 (단말기 차감은 자동 계산됩니다)
                                </small>
                            </div>

                            {offsetData.offsetAmt && (
                                <div className="form-group" style={{
                                    marginBottom: "15px",
                                    padding: "10px",
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "4px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        fontSize: "14px"
                                    }}>
                                        <span style={{ color: "#64748b" }}>상계 금액:</span>
                                        <span style={{
                                            fontWeight: "600",
                                            color: calculateOffsetAmount() > 0 ? "#dc2626" : "#059669"
                                        }}>
                                            {calculateOffsetAmount() > 0 ? "-" : "+"}{changeNum(Math.abs(calculateOffsetAmount()))}원
                                        </span>
                                    </div>
                                    <div style={{
                                        fontSize: "12px",
                                        color: "#64748b",
                                        marginTop: "4px"
                                    }}>
                                        {calculateOffsetAmount() > 0 ? "금액 감소 (상계)" : "금액 증가"}
                                    </div>
                                </div>
                            )}
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    상계 사유 *
                                </label>
                                <textarea
                                    value={offsetData.offsetMemo}
                                    onChange={(e) => setOffsetData({
                                        ...offsetData,
                                        offsetMemo: e.target.value
                                    })}
                                    className="form-control"
                                    placeholder="상계 처리 사유를 입력하세요"
                                    rows="3"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setOffsetModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleOffsetSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #3b82f6",
                                    borderRadius: "4px",
                                    backgroundColor: "#3b82f6",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                상계 처리
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 상계처리 이력 모달 - 기존 코드와 동일 (가맹점명 → 영업자명으로 변경) */}
            {offsetHistoryModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "600px",
                        maxWidth: "800px",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>상계처리 이력</h3>
                            <button
                                className="btn-close"
                                onClick={() => setOffsetHistoryModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {payoutInfo && (
                            <div style={{
                                backgroundColor: "#f8fafc",
                                padding: "15px",
                                borderRadius: "6px",
                                marginBottom: "20px",
                                border: "1px solid #e2e8f0"
                            }}>
                                <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#374151" }}>기본 정보</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontSize: "14px" }}>
                                    <div><strong>영업자명:</strong> {payoutInfo.co_nm || payoutInfo.agent_nm || payoutInfo.agent_name}</div>
                                    <div><strong>현재 금액:</strong> {changeNum(parseFloat(payoutInfo.requested_amount || 0))}원</div>
                                </div>
                            </div>
                        )}

                        <div style={{ marginBottom: "20px" }}>
                            <h4 style={{ margin: "0 0 15px 0", fontSize: "16px", color: "#374151" }}>상계처리 이력</h4>
                            {offsetHistory.length > 0 ? (
                                <div style={{ overflow: "auto", maxHeight: "400px" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                                                <th style={{ padding: "10px", textAlign: "left", fontWeight: "600" }}>처리일시</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 전</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 후</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 금액</th>
                                                <th style={{ padding: "10px", textAlign: "left", fontWeight: "600" }}>사유</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {offsetHistory.map((log, index) => (
                                                <tr key={log.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                                                    <td style={{ padding: "10px" }}>
                                                        {(() => {
                                                            if (!log.offset_at) return '-';
                                                            try {
                                                                // offset_at이 이미 한국 시간 형식이거나 UTC 형식일 수 있음
                                                                const dateStr = log.offset_at;
                                                                let date;
                                                                if (dateStr.includes('Z') || dateStr.includes('+')) {
                                                                    date = new Date(dateStr);
                                                                } else {
                                                                    // 한국 시간 형식인 경우
                                                                    date = new Date(dateStr.replace(' ', 'T') + '+09:00');
                                                                }
                                                                return date.toLocaleString('ko-KR', {
                                                                    timeZone: 'Asia/Seoul',
                                                                    year: 'numeric',
                                                                    month: '2-digit',
                                                                    day: '2-digit',
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    second: '2-digit',
                                                                    hour12: false
                                                                });
                                                            } catch (error) {
                                                                return log.offset_at;
                                                            }
                                                        })()}
                                                    </td>
                                                    <td style={{ padding: "10px", textAlign: "right" }}>
                                                        {changeNum(parseFloat(log.offset_before_amount || log.offset_before || 0))}원
                                                    </td>
                                                    <td style={{ padding: "10px", textAlign: "right" }}>
                                                        {changeNum(parseFloat(log.offset_after_amount || log.offset_after || 0))}원
                                                    </td>
                                                    <td style={{
                                                        padding: "10px",
                                                        textAlign: "right",
                                                        color: (() => {
                                                            const offsetAmount = parseFloat(log.offset_amount || 0);
                                                            if (offsetAmount === 0) {
                                                                const before = parseFloat(log.offset_before_amount || log.offset_before || 0);
                                                                const after = parseFloat(log.offset_after_amount || log.offset_after || 0);
                                                                return after < before ? "#dc2626" : "#059669";
                                                            }
                                                            return offsetAmount < 0 ? "#dc2626" : "#059669";
                                                        })(),
                                                        fontWeight: "600"
                                                    }}>
                                                        {(() => {
                                                            // offset_amount가 있으면 우선 사용
                                                            if (log.offset_amount !== undefined && log.offset_amount !== null) {
                                                                const offsetAmount = parseFloat(log.offset_amount || 0);
                                                                return (offsetAmount < 0 ? "-" : "+") + changeNum(Math.abs(offsetAmount)) + "원";
                                                            }
                                                            // 없으면 계산
                                                            const before = parseFloat(log.offset_before_amount || log.offset_before || 0);
                                                            const after = parseFloat(log.offset_after_amount || log.offset_after || 0);
                                                            const diff = after - before;
                                                            return (diff < 0 ? "-" : "+") + changeNum(Math.abs(diff)) + "원";
                                                        })()}
                                                    </td>
                                                    <td style={{ padding: "10px" }}>
                                                        {log.offset_memo || "-"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: "center",
                                    padding: "40px",
                                    color: "#6b7280",
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "6px"
                                }}>
                                    상계처리 이력이 없습니다.
                                </div>
                            )}
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setOffsetHistoryModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 계좌 분할 모달 */}
            {splitModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "500px",
                        maxWidth: "600px",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>계좌 분할</h3>
                            <button
                                className="btn-close"
                                onClick={() => setSplitModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {selectedSplitRow && (
                            <div style={{
                                backgroundColor: "#f0f9ff",
                                padding: "16px",
                                borderRadius: "6px",
                                marginBottom: "20px"
                            }}>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                    <div><strong>영업자명:</strong> {selectedSplitRow.co_nm || selectedSplitRow.agent_name}</div>
                                    <div><strong>원본 금액:</strong> {changeNum(selectedSplitRow.requested_amount)}원</div>
                                </div>
                            </div>
                        )}

                        <div style={{ display: "grid", gap: "20px" }}>
                            {/* 첫 번째 계좌 */}
                            <div>
                                <h4 style={{ marginBottom: "12px", color: "#374151", fontSize: "16px" }}>
                                    첫 번째 계좌 (기존 계좌 정보)
                                </h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            영업자명 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstMerchantName}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstMerchantName: e.target.value }))}
                                            placeholder="영업자명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 영업자명이 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            은행 선택 *
                                        </label>
                                        <select
                                            value={splitData.firstBankCode}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstBankCode: e.target.value }))}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        >
                                            <option value="">은행을 선택하세요</option>
                                            {bankInfoList.map(bank => (
                                                <option key={bank.code} value={bank.code}>
                                                    {bank.bank_name}
                                                </option>
                                            ))}
                                        </select>
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 은행이 미리 선택됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            계좌번호 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAccountNumber}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstAccountNumber: e.target.value }))}
                                            placeholder="계좌번호를 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 계좌번호가 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            예금주 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAccountHolder}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstAccountHolder: e.target.value }))}
                                            placeholder="예금주명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 예금주명이 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            분할 금액 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAmount}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                setSplitData(prev => ({ ...prev, firstAmount: value }));
                                                setTimeout(() => {
                                                    const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
                                                    const firstAmount = parseFloat(value || 0);
                                                    const secondAmount = totalAmount - firstAmount;
                                                    setSplitData(prev => ({
                                                        ...prev,
                                                        secondAmount: secondAmount > 0 ? secondAmount.toString() : ''
                                                    }));
                                                }, 0);
                                            }}
                                            placeholder="첫 번째 계좌 분할 금액을 입력하세요 (숫자만)"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            메모
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstMemo}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstMemo: e.target.value }))}
                                            placeholder="첫 번째 계좌 메모"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 두 번째 계좌 */}
                            <div>
                                <h4 style={{ marginBottom: "12px", color: "#374151", fontSize: "16px" }}>두 번째 계좌</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            영업자명 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondMerchantName}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondMerchantName: e.target.value }))}
                                            placeholder="영업자명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            은행 선택 *
                                        </label>
                                        <select
                                            value={splitData.secondBankCode}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondBankCode: e.target.value }))}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        >
                                            <option value="">은행을 선택하세요</option>
                                            {bankInfoList.map(bank => (
                                                <option key={bank.code} value={bank.code}>
                                                    {bank.bank_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            계좌번호 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAccountNumber}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondAccountNumber: e.target.value }))}
                                            placeholder="계좌번호를 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            예금주 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAccountHolder}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondAccountHolder: e.target.value }))}
                                            placeholder="예금주명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            분할 금액 (자동 계산)
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAmount}
                                            readOnly
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                backgroundColor: "#f9fafb",
                                                color: "#6b7280"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            메모
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondMemo}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondMemo: e.target.value }))}
                                            placeholder="두 번째 계좌 메모"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 분할 사유 */}
                            <div>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                    분할 사유
                                </label>
                                <input
                                    type="text"
                                    value={splitData.splitReason}
                                    onChange={(e) => setSplitData(prev => ({ ...prev, splitReason: e.target.value }))}
                                    placeholder="계좌 분할 사유를 입력하세요"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        fontSize: "14px"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "8px",
                            paddingTop: "20px",
                            borderTop: "1px solid #e5e7eb",
                            marginTop: "20px"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setSplitModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSplitSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                계좌 분할
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 분할 이력 모달 */}
            {splitHistoryModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        maxWidth: "800px",
                        width: "90%",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>분할 이력</h3>
                            <button
                                className="btn-close"
                                onClick={() => setSplitHistoryModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {splitPayoutInfo && (
                            <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8fafc", borderRadius: "6px" }}>
                                <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#374151" }}>분할 정보</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontSize: "14px" }}>
                                    <div><strong>분할 사유:</strong> {splitPayoutInfo.split_reason}</div>
                                    <div><strong>분할 일시:</strong> {new Date(splitPayoutInfo.split_created_at).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' })}</div>
                                </div>
                            </div>
                        )}

                        <div style={{ marginBottom: "20px" }}>
                            <h4 style={{ margin: "0 0 15px 0", fontSize: "16px", color: "#374151" }}>분할 계좌 상세</h4>
                            {splitHistory.length > 0 ? (
                                <div style={{ overflow: "auto", maxHeight: "400px" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>구분</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>영업자명</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>은행</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>계좌번호</th>
                                                <th style={{ padding: "12px", textAlign: "right", fontWeight: "600", color: "#374151" }}>금액</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>메모</th>
                                                <th style={{ padding: "12px", textAlign: "center", fontWeight: "600", color: "#374151" }}>상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {splitHistory.map((log, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #e5e7eb" }}>
                                                    <td style={{ padding: "12px", fontWeight: "500", color: "#1e40af" }}>첫 번째</td>
                                                    <td style={{ padding: "12px" }}>{log.first_agent_nm || log.first_co_nm || log.first_agent_name || '-'}</td>
                                                    <td style={{ padding: "12px" }}>{getBankName(log.first_bank_code)}</td>
                                                    <td style={{ padding: "12px" }}>
                                                        {renderRevealAccountCell({
                                                            enabled: isBaekmaTestAdmin,
                                                            id: log.id || log.log_id,
                                                            value: getSplitAccountNumberDisplay(log, 'first'),
                                                            revealed: !!getRevealedSplitAccount(log.id || log.log_id),
                                                            loading: isSplitRevealLoading(log.id || log.log_id),
                                                            onReveal: revealSplitAccount,
                                                        })}
                                                    </td>
                                                    <td style={{ padding: "12px", textAlign: "right", fontWeight: "500" }}>{changeNum(log.first_amount)}원</td>
                                                    <td style={{ padding: "12px" }}>{log.first_memo || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "center" }}>
                                                        <span style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            backgroundColor: log.first_status === 'W' ? "#fef3c7" : "#d1fae5",
                                                            color: log.first_status === 'W' ? "#92400e" : "#065f46"
                                                        }}>
                                                            {log.first_status === 'W' ? '대기' : log.first_status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            {splitHistory.map((log, index) => (
                                                <tr key={`second-${index}`} style={{ borderBottom: "1px solid #e5e7eb" }}>
                                                    <td style={{ padding: "12px", fontWeight: "500", color: "#1e40af" }}>두 번째</td>
                                                    <td style={{ padding: "12px" }}>{log.second_agent_nm || log.second_co_nm || log.second_agent_name || '-'}</td>
                                                    <td style={{ padding: "12px" }}>{getBankName(log.second_bank_code)}</td>
                                                    <td style={{ padding: "12px" }}>
                                                        {renderRevealAccountCell({
                                                            enabled: isBaekmaTestAdmin,
                                                            id: log.id || log.log_id,
                                                            value: getSplitAccountNumberDisplay(log, 'second'),
                                                            revealed: !!getRevealedSplitAccount(log.id || log.log_id),
                                                            loading: isSplitRevealLoading(log.id || log.log_id),
                                                            onReveal: revealSplitAccount,
                                                        })}
                                                    </td>
                                                    <td style={{ padding: "12px", textAlign: "right", fontWeight: "500" }}>{changeNum(log.second_amount)}원</td>
                                                    <td style={{ padding: "12px" }}>{log.second_memo || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "center" }}>
                                                        <span style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            backgroundColor: log.second_status === 'W' ? "#fef3c7" : "#d1fae5",
                                                            color: log.second_status === 'W' ? "#92400e" : "#065f46"
                                                        }}>
                                                            {log.second_status === 'W' ? '대기' : log.second_status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: "center",
                                    padding: "40px",
                                    color: "#6b7280",
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "6px"
                                }}>
                                    분할 이력이 없습니다.
                                </div>
                            )}
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingTop: "20px",
                            borderTop: "1px solid #e5e7eb",
                            marginTop: "20px"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setSplitHistoryModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 단말기 개수 적용 모달 */}
            {terminalModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "400px",
                        maxWidth: "500px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>단말기 개수 적용</h3>
                            <button
                                className="btn-close"
                                onClick={() => setTerminalModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    영업자명
                                </label>
                                <input
                                    type="text"
                                    value={selectedTerminalRow?.co_nm || selectedTerminalRow?.agent_name || ''}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    단말기 차감 전 금액
                                </label>
                                <input
                                    type="text"
                                    value={changeNum(parseFloat(selectedTerminalRow?.requested_amount || 0))}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    단말기 개수 *
                                </label>
                                <input
                                    type="text"
                                    value={terminalData.terminalCount}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setTerminalData({
                                            ...terminalData,
                                            terminalCount: value
                                        });
                                    }}
                                    className="form-control"
                                    placeholder="단말기 개수를 입력하세요 (숫자만)"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px"
                                    }}
                                />
                                <small style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                    개당 11,000원이 자동 차감됩니다
                                </small>
                            </div>

                            {terminalData.terminalCount && (
                                <div className="form-group" style={{
                                    marginBottom: "15px",
                                    padding: "10px",
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "4px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        fontSize: "14px",
                                        marginBottom: "4px"
                                    }}>
                                        <span style={{ color: "#64748b" }}>차감 금액:</span>
                                        <span style={{
                                            fontWeight: "600",
                                            color: "#dc2626"
                                        }}>
                                            -{changeNum(parseInt(terminalData.terminalCount || 0) * 11000)}원
                                        </span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        fontSize: "14px"
                                    }}>
                                        <span style={{ color: "#64748b" }}>적용 후 최종 금액:</span>
                                        <span style={{
                                            fontWeight: "600",
                                            color: "#059669"
                                        }}>
                                            {changeNum(parseFloat(selectedTerminalRow?.requested_amount || 0) - (parseInt(terminalData.terminalCount || 0) * 11000))}원
                                        </span>
                                    </div>
                                </div>
                            )}
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    메모
                                </label>
                                <textarea
                                    value={terminalData.terminalMemo}
                                    onChange={(e) => setTerminalData({
                                        ...terminalData,
                                        terminalMemo: e.target.value
                                    })}
                                    className="form-control"
                                    placeholder="단말기 개수 적용 메모 (선택사항)"
                                    rows="3"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setTerminalModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleTerminalSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #3b82f6",
                                    borderRadius: "4px",
                                    backgroundColor: "#3b82f6",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                적용
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 보류 처리 모달 */}
            {holdModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "400px",
                        maxWidth: "500px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>보류 처리</h3>
                            <button
                                className="btn-close"
                                onClick={() => setHoldModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    영업자명
                                </label>
                                <input
                                    type="text"
                                    value={selectedHoldRow?.co_nm || selectedHoldRow?.agent_name || ''}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    정산기간
                                </label>
                                <input
                                    type="text"
                                    value={selectedHoldRow?.settlement_month || '-'}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    보류 사유 (선택)
                                </label>
                                <textarea
                                    value={holdData.adminMemo}
                                    onChange={(e) => setHoldData({
                                        ...holdData,
                                        adminMemo: e.target.value
                                    })}
                                    className="form-control"
                                    placeholder="보류 사유를 입력하세요 (선택사항)"
                                    rows="3"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setHoldModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleHoldSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #f59e0b",
                                    borderRadius: "4px",
                                    backgroundColor: "#f59e0b",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                보류 처리
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 보류 해제 모달 */}
            {releaseModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "400px",
                        maxWidth: "500px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>보류 해제</h3>
                            <button
                                className="btn-close"
                                onClick={() => setReleaseModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    영업자명
                                </label>
                                <input
                                    type="text"
                                    value={selectedReleaseRow?.co_nm || selectedReleaseRow?.agent_name || ''}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    정산기간
                                </label>
                                <input
                                    type="text"
                                    value={selectedReleaseRow?.settlement_month || '-'}
                                    disabled
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                                <label style={{
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    보류 해제 사유 (선택)
                                </label>
                                <textarea
                                    value={releaseData.adminMemo}
                                    onChange={(e) => setReleaseData({
                                        ...releaseData,
                                        adminMemo: e.target.value
                                    })}
                                    className="form-control"
                                    placeholder="보류 해제 사유를 입력하세요 (선택사항)"
                                    rows="3"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setReleaseModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleReleaseSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #10b981",
                                    borderRadius: "4px",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                보류 해제
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '입금예정 영업자내역';

    const headerRow = [
        "정산기간", "영업자명", "입금액", "예금주", "입금계좌", "은행", "적요"
    ];

    const bodyRows = excelData.map((data) => ([
        data.정산기간, data.영업자명, Number(data.입금액), data.예금주, data.입금계좌, data.은행, data.적요
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementAgentDepositStay
